import { render, staticRenderFns } from "./DocAttachment.vue?vue&type=template&id=4c7982c0&"
import script from "./DocAttachment.vue?vue&type=script&lang=js&"
export * from "./DocAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports